module.exports = __webpack_public_path__ + "static/img/CN.bb343258.jpg";